import React from 'react';
var TabContext = React.createContext(null);
export default TabContext;